const successSnackbar = ({ commit }, message) => {
    commit('RESET_STATE')
    commit('SHOW_SNACKBAR', {
        color: 'success',
        message: message,
        active: true,
    })
    setTimeout(() => {
        commit('RESET_STATE')
    }, 5000)
}

const errorSnackbar = ({ commit }, message) => {
    commit('RESET_STATE')
    commit('SHOW_SNACKBAR', {
        color: 'error',
        message: message,
        active: true,
    })
    setTimeout(() => {
        commit('RESET_STATE')
    }, 7000)
}

const killSnackbar = ({ commit }) => commit('RESET_STATE')

const resetState = function({ commit }, obj) {
    commit('SET_CURRENT_LIST', obj.data)
    commit('SET_CURRENT_MODEL', obj.model)
    commit('SET_CURRENT_PAGINATION', obj.pagination)
}

export default {
    successSnackbar,
    errorSnackbar,
    killSnackbar,
    resetState,
}
